module.exports = __webpack_public_path__ + "img/close-filter-light.9ecaf69a.svg";